import { type PartialDictionary } from './en-GB';

/**
 * Global English.
 *
 * Overrides only, and only where British wording would be *wrong* elsewhere —
 * not merely unusual. There are two such strings today.
 *
 * The GPhC regulates pharmacy in Great Britain. Claiming GPhC registration to
 * someone outside it is a false regulatory claim, which is a compliance
 * problem rather than a translation one; the global line states the same fact
 * without naming a regulator that does not apply.
 *
 * Everything else falls through to `en-GB`. That is the intended shape of a
 * fallback dictionary, and it is why this file is three keys rather than two
 * hundred duplicated ones.
 */
export const en: PartialDictionary = {
  'footer.legalLine': '© {year} Just Treated. All rights reserved.',
  'footer.regionLabel': 'Global · English',
  'locale.note':
    'Just Treated is written in English today. More languages will appear here as they are translated — none is listed before it exists.',
};
